// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3s8XR","ranges":"BmiRanges_ranges__1lVP7"};